"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = require("react");
var _reducer = require("../store/reducer");
var _store = require("../store/store");
var _queryBuilder = require("../utils/queryBuilder");
var _types = _interopRequireDefault(require("../store/types"));
var _stateTypes = _interopRequireDefault(require("../store/stateTypes"));
var _arcgisRestPortal = require("@esri/arcgis-rest-portal");
var _helper = require("../utils/helper");
var _arcgisRestAuth = require("@esri/arcgis-rest-auth");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }
function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0) { ; } } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
var useItemBrowserState = function useItemBrowserState(userAccount, itemBrowserOptions) {
  var showFolderFilter = itemBrowserOptions.showFolderFilter,
    showUserFilter = itemBrowserOptions.showUserFilter,
    queryScope = itemBrowserOptions.queryScope,
    urlSearchParams = itemBrowserOptions.urlSearchParams,
    onUrlParamsUpdated = itemBrowserOptions.onUrlParamsUpdated,
    customCellRenderer = itemBrowserOptions.customCellRenderer,
    customFilterGroupTitles = itemBrowserOptions.customFilterGroupTitles,
    customItemTypesTitles = itemBrowserOptions.customItemTypesTitles,
    customTableColumnConfig = itemBrowserOptions.customTableColumnConfig;
  var initialStore = (0, _store.checkForCustomFilters)({
    customFilterGroupTitles: customFilterGroupTitles,
    customItemTypesTitles: customItemTypesTitles
  });
  var _useReducer = (0, _react.useReducer)(_reducer.reducer, initialStore),
    _useReducer2 = _slicedToArray(_useReducer, 2),
    itemBrowserState = _useReducer2[0],
    dispatchItemBrowser = _useReducer2[1];
  var _useState = (0, _react.useState)({}),
    _useState2 = _slicedToArray(_useState, 2),
    queryResults = _useState2[0],
    setQueryResults = _useState2[1];
  var _useState3 = (0, _react.useState)({}),
    _useState4 = _slicedToArray(_useState3, 2),
    itemGroups = _useState4[0],
    setItemGroups = _useState4[1];
  var _useState5 = (0, _react.useState)([]),
    _useState6 = _slicedToArray(_useState5, 2),
    selectedItemIds = _useState6[0],
    setSelectedItemIds = _useState6[1];
  var _useState7 = (0, _react.useState)((urlSearchParams === null || urlSearchParams === void 0 ? void 0 : urlSearchParams.get("sortField")) || "modified"),
    _useState8 = _slicedToArray(_useState7, 2),
    sortField = _useState8[0],
    setSortField = _useState8[1];
  var _useState9 = (0, _react.useState)((urlSearchParams === null || urlSearchParams === void 0 ? void 0 : urlSearchParams.get("sortOrder")) || "desc"),
    _useState10 = _slicedToArray(_useState9, 2),
    sortOrder = _useState10[0],
    setSortOrder = _useState10[1];
  var _useState11 = (0, _react.useState)(userAccount === null || userAccount === void 0 ? void 0 : userAccount.portal),
    _useState12 = _slicedToArray(_useState11, 2),
    portal = _useState12[0],
    setPortal = _useState12[1];
  var _useState13 = (0, _react.useState)(userAccount === null || userAccount === void 0 ? void 0 : userAccount.session),
    _useState14 = _slicedToArray(_useState13, 2),
    session = _useState14[0],
    setSession = _useState14[1];
  var _useState15 = (0, _react.useState)(userAccount === null || userAccount === void 0 ? void 0 : userAccount.user),
    _useState16 = _slicedToArray(_useState15, 2),
    user = _useState16[0],
    setUser = _useState16[1];
  var _useState17 = (0, _react.useState)(urlSearchParams),
    _useState18 = _slicedToArray(_useState17, 2),
    urlParams = _useState18[0],
    setUrlParams = _useState18[1];
  var _useState19 = (0, _react.useState)(queryScope),
    _useState20 = _slicedToArray(_useState19, 2),
    previousScope = _useState20[0],
    setPreviousScope = _useState20[1];
  var defaultUrlParamKeys = ["folder", "num", "start", "sortField", "sortOrder"];
  var columnConfig = customTableColumnConfig ? customTableColumnConfig : _helper.tableColumnConfig;
  var urlParamsUpdated = (0, _react.useCallback)(function (newParams) {
    if (urlSearchParams && onUrlParamsUpdated) {
      Object.entries(newParams).forEach(function (_ref) {
        var _ref2 = _slicedToArray(_ref, 2),
          key = _ref2[0],
          value = _ref2[1];
        // If particular param value is not null, set it to URL params
        if (value !== null) {
          // If param already exists, remove existing param value before appending updated value.
          if (urlSearchParams.has(key)) {
            urlSearchParams.delete(key);
          }

          // Append param to urlSearchParams
          urlSearchParams.append(key, value);
        } else if (!defaultUrlParamKeys.includes(key)) {
          // If particular param value is null and is not one of the default URL params that should always be visible, remove said param from URL params
          urlSearchParams.delete(key);
        }
      });

      // Check to see if urlSearchParams contain all required params specified in defaultUrlParamKeys and that urlSearchParams isn't a duplicate of current window.location.search before setting new urlSearchParams
      var urlParamsReadyToUpdate = true;
      var urlParamsHaveChanged = "?".concat(urlSearchParams.toString()) !== window.location.search;
      defaultUrlParamKeys.forEach(function (defaultParam) {
        if (!urlSearchParams.has(defaultParam)) {
          urlParamsReadyToUpdate = false;
        }
      });
      if (urlParamsReadyToUpdate && urlParamsHaveChanged) {
        onUrlParamsUpdated(urlSearchParams);
        setUrlParams(newParams);
      }
    }
  }, [defaultUrlParamKeys, onUrlParamsUpdated, urlSearchParams]);
  var queryHasChanged = (0, _react.useCallback)(function (searchParams, newActionUpdate) {
    if (newActionUpdate || searchParams.q !== queryResults.query || searchParams.num !== queryResults.num || searchParams.start !== queryResults.start || searchParams.sortField !== sortField || searchParams.sortOrder !== sortOrder) {
      return true;
    }
    return false;
  }, [queryResults.num, queryResults.query, queryResults.start, sortField, sortOrder]);

  /* getItemGroupsFromQueryResult() - Returns object containing keys for all item ids that belong to groups, with values consisting arrays of objects containing data for all group ids that each item is a part of.  Properties in group objects include groupId, groupTitle used in ToolTip label when hovering over group icon ItemTable and groupLetter used as letter in group icon in ItemTable.
  
  Ex. 
   {
      "itemId-5c6dada9d18244c381734524b3702bdd": [
        {
          "groupId": "71f492455ab74e3181a4cc10a47c8b31",
          "groupTitle": "Emergency Management Collaboration",
          "groupLetter": "E"
        },
        {
          "groupId": "5c782cd2035e4221a48b36c785dcf7ca",
          "groupTitle": "HTTPS / HTTP Testing",
          "groupLetter": "H"
        },
        {
          "groupId": "6797ba6de1cd40c3882da5cb6af80125",
          "groupTitle": "Citi - EOC",
          "groupLetter": "C"
        }
      ] 
    }
   */
  var getItemGroupsFromQueryResult = (0, _react.useCallback)( /*#__PURE__*/function () {
    var _ref3 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(result, authentication) {
      var itemIds, groupIds, itemGroupsResult;
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              itemIds = result.results.map(function (item) {
                return item.id;
              }).join();
              groupIds = user.groups.map(function (group) {
                return group.id;
              }).join();
              _context.next = 4;
              return (0, _helper.getItemGroups)({
                portal: portal,
                itemIds: itemIds,
                groupIds: groupIds,
                authentication: authentication
              });
            case 4:
              itemGroupsResult = _context.sent;
              return _context.abrupt("return", itemGroupsResult);
            case 6:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));
    return function (_x, _x2) {
      return _ref3.apply(this, arguments);
    };
  }(), [portal, user]);

  // Checks if particular query param is different from url param value for said query param value
  var queryParamHasChanged = (0, _react.useCallback)(function (key, value) {
    if ((urlParams === null || urlParams === void 0 ? void 0 : urlParams.get) && urlParams.get(key) !== value) {
      return true;
    } else if ((urlParams === null || urlParams === void 0 ? void 0 : urlParams[key]) !== value) {
      return true;
    }
    return false;
  }, [urlParams]);

  // Functionality for formatting free text search for use in query
  var formatQuerySearchTerm = (0, _react.useCallback)(function (currentQuery, searchTerm) {
    if (searchTerm) {
      var updatedQuery = "".concat(currentQuery, " (").concat(searchTerm, ")");
      return updatedQuery;
    }
    return currentQuery;
  }, []);
  var handleQueryChange = (0, _react.useCallback)( /*#__PURE__*/function () {
    var _ref5 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(_ref4) {
      var updatedQuery, start, num, sortBy, sortDirection, newActionUpdate, allItemsVisibleOnSinglePage, q, searchParams, paths, updatedUrlParams, _userAccount$user, result, newQueryResults, resultsItemGroups;
      return regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              updatedQuery = _ref4.updatedQuery, start = _ref4.start, num = _ref4.num, sortBy = _ref4.sortBy, sortDirection = _ref4.sortDirection, newActionUpdate = _ref4.newActionUpdate;
              _context2.prev = 1;
              if (!(session || userAccount && !userAccount.session)) {
                _context2.next = 25;
                break;
              }
              /* The 'allItemsVisibleOnSinglePage' variable checks to see if 'start' param 
              should be automatically set to 1 in order to display total 
              number of items on single page.  If user selects a page higher than 1
              in pagination and then changes the number of items visible per page to a number
              greater than the total items, all the items should be displayed on 1 page and
              the URL params should reflect this. */
              allItemsVisibleOnSinglePage = (queryResults === null || queryResults === void 0 ? void 0 : queryResults.total) < queryResults.num ? true : false;
              q = formatQuerySearchTerm((updatedQuery === null || updatedQuery === void 0 ? void 0 : updatedQuery.q) || queryResults.query);
              searchParams = {
                q: q,
                sortField: sortBy || sortField,
                sortOrder: sortDirection || sortOrder,
                num: num || queryResults.num || (urlParams === null || urlParams === void 0 ? void 0 : urlParams.get) && (urlParams === null || urlParams === void 0 ? void 0 : urlParams.get("num")) || (urlParams === null || urlParams === void 0 ? void 0 : urlParams.num) || 20,
                // Default start value is 1. This is to prevent start value from being assigned value of previous start when changing num param value.
                start: start || allItemsVisibleOnSinglePage && (urlParams === null || urlParams === void 0 ? void 0 : urlParams.get) && (urlParams === null || urlParams === void 0 ? void 0 : urlParams.get("start")) || allItemsVisibleOnSinglePage && (urlParams === null || urlParams === void 0 ? void 0 : urlParams.start) || 1
              }; // If user clicks My Organization tab, check if session portal url contains 'rest'. If not, add it to the end of the url passed to searchParams.  This is to fix an error causing the user's items in the My Organization tab to not display.
              // Applied to USER queryScope to fix bug where search requests from My Content without "/rest" returned items without a "created" field
              if (queryScope === "ORGANIZATION" || queryScope === "USER") {
                paths = session.portal.split("/");
                if (!paths.includes("rest")) {
                  paths.push("rest");
                }
                searchParams.portal = paths.join("/");
              }

              // If the current queryScope is ONLINE, use anonymous UserSession for authentication.  This will ensure that when the user clicks the ArcGIS Online tab, they will browse ArcGIS Online items regardless of whether they are signed into Enterprise or ArcGIS Online.
              if (queryScope === "ONLINE") {
                searchParams.authentication = new _arcgisRestAuth.UserSession({});
              } else {
                searchParams.authentication = session || userAccount;
              }
              updatedUrlParams = {
                num: searchParams.num,
                start: searchParams.start,
                sortField: searchParams.sortField,
                sortOrder: searchParams.sortOrder
              };
              if (!((searchParams === null || searchParams === void 0 ? void 0 : searchParams.q) !== undefined && (searchParams === null || searchParams === void 0 ? void 0 : searchParams.q) !== "" && queryHasChanged(searchParams, newActionUpdate))) {
                _context2.next = 25;
                break;
              }
              if ((searchParams === null || searchParams === void 0 ? void 0 : searchParams.q) == undefined | (searchParams === null || searchParams === void 0 ? void 0 : searchParams.q) == "") {
                searchParams.q = "owner:".concat(userAccount === null || userAccount === void 0 ? void 0 : (_userAccount$user = userAccount.user) === null || _userAccount$user === void 0 ? void 0 : _userAccount$user.username);
              }
              _context2.next = 13;
              return (0, _arcgisRestPortal.searchItems)(searchParams);
            case 13:
              result = _context2.sent;
              if (!result) {
                _context2.next = 25;
                break;
              }
              // manually add the query used to get results so it can be referenced in queryResults. This is used to persist the query in pagination
              newQueryResults = _objectSpread(_objectSpread({}, result), {}, {
                query: searchParams.q
              });
              setQueryResults(newQueryResults);

              // Gets and sets itemsgroups
              _context2.next = 19;
              return getItemGroupsFromQueryResult(result, searchParams.authentication);
            case 19:
              resultsItemGroups = _context2.sent;
              setItemGroups(resultsItemGroups);

              // Checks to see if query params have changed to see which url params need to be updated
              Object.entries(updatedUrlParams).forEach(function (_ref6) {
                var _ref7 = _slicedToArray(_ref6, 2),
                  key = _ref7[0],
                  value = _ref7[1];
                if (queryParamHasChanged(key, value)) {
                  updatedUrlParams[key] = value;
                }
              });
              if (sortBy) setSortField(sortBy);
              if (sortDirection) setSortOrder(sortDirection);

              // If custom urlParamsUpdated function exists, use that to update URL params.  Otherwise, use default urlParamsUpdated.

              itemBrowserOptions.urlParamsUpdated ? itemBrowserOptions.urlParamsUpdated(updatedUrlParams) : urlParamsUpdated(updatedUrlParams);
            case 25:
              _context2.next = 31;
              break;
            case 27:
              _context2.prev = 27;
              _context2.t0 = _context2["catch"](1);
              console.warn(_context2.t0);
              setQueryResults({});
            case 31:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2, null, [[1, 27]]);
    }));
    return function (_x3) {
      return _ref5.apply(this, arguments);
    };
  }(), [formatQuerySearchTerm, getItemGroupsFromQueryResult, itemBrowserOptions, queryHasChanged, queryParamHasChanged, queryResults, queryScope, session, sortField, sortOrder, urlParams, urlParamsUpdated, userAccount]);

  // Called by handleStateUpdate(), sets state via useReducer()
  var onStateChange = (0, _react.useCallback)( /*#__PURE__*/function () {
    var _ref8 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3(updatedState) {
      return regeneratorRuntime.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              if (updatedState) {
                dispatchItemBrowser({
                  type: _types.default.UPDATE_STATE_MAIN,
                  updatedState: updatedState
                });
              }
            case 1:
            case "end":
              return _context3.stop();
          }
        }
      }, _callee3);
    }));
    return function (_x4) {
      return _ref8.apply(this, arguments);
    };
  }(), []);

  // Currently active user as reflected in state
  var currentUsername = (0, _react.useMemo)(function () {
    var currentUser = itemBrowserState.users.items.allIds.find(function (id) {
      return itemBrowserState.users.items.byId[id].state === _stateTypes.default.USER_ITEM_ACTIVE;
    });
    return currentUser;
  }, [itemBrowserState.users.items.allIds, itemBrowserState.users.items.byId]);

  // Called anytime state updates
  var handleUrlParamUpdates = (0, _react.useCallback)(function (updatedState) {
    // Get any active FilterItems/FilterItemOptions and update URL params accordingly

    var updatedUrlParams = (0, _helper.formatUrlParamUpdates)({
      updatedState: updatedState,
      urlParams: urlParams
    });
    setUrlParams(updatedUrlParams);

    // If custom urlParamsUpdated function exists, use that to update URL params.  Otherwise, use default urlParamsUpdated
    itemBrowserOptions.urlParamsUpdated ? itemBrowserOptions.urlParamsUpdated(updatedUrlParams) : urlParamsUpdated(updatedUrlParams);
  }, [itemBrowserOptions, urlParams, urlParamsUpdated]);

  // userAccount username depending on whether userAccount is REST JS UserSession or account from useAccountManager
  var userAccountUsername = (0, _react.useMemo)(function () {
    var accountUsername = (userAccount === null || userAccount === void 0 ? void 0 : userAccount.username) || (userAccount === null || userAccount === void 0 ? void 0 : userAccount.user.username);
    return accountUsername;
  }, [userAccount]);

  // Called anytime items are filtered from ItemBrowser
  var handleStateUpdate = (0, _react.useCallback)( /*#__PURE__*/function () {
    var _ref9 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4(stateUpdates, username, customModifiedUploadedUrlParams) {
      var updatedState, updatedQuery;
      return regeneratorRuntime.wrap(function _callee4$(_context4) {
        while (1) {
          switch (_context4.prev = _context4.next) {
            case 0:
              _context4.prev = 0;
              updatedState = stateUpdates ? _objectSpread(_objectSpread({}, itemBrowserState), stateUpdates) : _objectSpread({}, itemBrowserState); // If URL params exist upon load of page for custom modified/uploaded date ranges, update state with startDate and endDate for custom modified/created
              if (customModifiedUploadedUrlParams && Object.keys(customModifiedUploadedUrlParams).length) {
                Object.entries(customModifiedUploadedUrlParams).forEach(function (_ref10) {
                  var _ref11 = _slicedToArray(_ref10, 2),
                    key = _ref11[0],
                    value = _ref11[1];
                  updatedState.filters.items.byId[key] = _objectSpread(_objectSpread({}, updatedState.filters.items.byId[key]), value);
                });
              }
              _context4.next = 5;
              return (0, _queryBuilder.queryBuilder)({
                itemBrowserState: updatedState,
                itemBrowserOptions: itemBrowserOptions,
                orgId: portal === null || portal === void 0 ? void 0 : portal.id,
                currentUsername: username ? username : currentUsername
              });
            case 5:
              updatedQuery = _context4.sent;
              updatedQuery.q = formatQuerySearchTerm(updatedQuery.q, updatedState.searchTerm);
              handleQueryChange({
                updatedQuery: updatedQuery
              });
              if (stateUpdates) {
                onStateChange(updatedState);
                if (urlParams) {
                  handleUrlParamUpdates(updatedState);
                }
              }
              _context4.next = 14;
              break;
            case 11:
              _context4.prev = 11;
              _context4.t0 = _context4["catch"](0);
              console.warn(_context4.t0);
            case 14:
            case "end":
              return _context4.stop();
          }
        }
      }, _callee4, null, [[0, 11]]);
    }));
    return function (_x5, _x6, _x7) {
      return _ref9.apply(this, arguments);
    };
  }(), [currentUsername, formatQuerySearchTerm, handleQueryChange, handleUrlParamUpdates, itemBrowserOptions, itemBrowserState, onStateChange, portal, urlParams]);
  (0, _react.useEffect)(function () {
    var handleQueryScopeUpdate = /*#__PURE__*/function () {
      var _ref12 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee5() {
        return regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                _context5.next = 2;
                return handleStateUpdate();
              case 2:
                setPreviousScope(queryScope);
              case 3:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5);
      }));
      return function handleQueryScopeUpdate() {
        return _ref12.apply(this, arguments);
      };
    }();
    if (queryScope !== previousScope) {
      handleQueryScopeUpdate();
    }
  }, [handleStateUpdate, itemBrowserOptions, previousScope, queryScope]);
  var filterItemsAreActive = (0, _react.useCallback)(function () {
    if (urlParams === null || urlParams === void 0 ? void 0 : urlParams.get) {
      if (urlParams.get("modified") || urlParams.get("uploaded") || urlParams.get("focus")) {
        return true;
      }
    } else if ((urlParams === null || urlParams === void 0 ? void 0 : urlParams.modified) || (urlParams === null || urlParams === void 0 ? void 0 : urlParams.uploaded) || (urlParams === null || urlParams === void 0 ? void 0 : urlParams.focus)) {
      return true;
    }
    return false;
  }, [urlParams]);

  // Called on startup
  var getUserFolders = (0, _react.useCallback)( /*#__PURE__*/function () {
    var _ref13 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee6(username, updatedUsersStore) {
      var usernameParam, userContent, folderStateParams, updatedUserFolders, updatedState, searchTerm, updatedFilters;
      return regeneratorRuntime.wrap(function _callee6$(_context6) {
        while (1) {
          switch (_context6.prev = _context6.next) {
            case 0:
              _context6.prev = 0;
              usernameParam = username ? username : currentUsername;
              if (!((session === null || session === void 0 ? void 0 : session.portal) && usernameParam)) {
                _context6.next = 13;
                break;
              }
              _context6.next = 5;
              return (0, _arcgisRestPortal.getUserContent)({
                owner: usernameParam,
                portal: session.portal,
                authentication: session
              });
            case 5:
              userContent = _context6.sent;
              folderStateParams = {
                userFolders: userContent === null || userContent === void 0 ? void 0 : userContent.folders.sort(function (a, b) {
                  // Prioritize underscores to be closer to AGO sorting conventions
                  return a.title.toLowerCase().replace("_", " ") > b.title.toLowerCase().replace("_", " ") ? 1 : -1;
                }),
                currentUsername: username ? username : currentUsername
              };
              if (urlParams) {
                folderStateParams.folderUrlParam = (urlParams === null || urlParams === void 0 ? void 0 : urlParams.get) ? urlParams.get("folder") : urlParams.folder;
              }
              updatedUserFolders = (0, _store.getUpdatedFoldersState)(folderStateParams);
              updatedState = {
                folders: updatedUserFolders,
                users: updatedUsersStore ? updatedUsersStore : itemBrowserState.users
              };
              /* Checks to see if there is an existing URL param for search term and if there is, add it as itemBrowserState.searchTerm value */
              if (urlParams && urlParams.get) {
                searchTerm = urlParams.get("searchTerm");
                if (searchTerm) {
                  updatedState.searchTerm = searchTerm;
                }
              }

              // Initial setting of itemBrowserState
              if (filterItemsAreActive()) {
                updatedFilters = (0, _store.getUpdatedFiltersState)({
                  filters: itemBrowserState.filters,
                  urlParams: {
                    modified: urlParams.get ? urlParams.get("modified") : urlParams === null || urlParams === void 0 ? void 0 : urlParams.modified,
                    uploaded: urlParams.get ? urlParams.get("uploaded") : urlParams === null || urlParams === void 0 ? void 0 : urlParams.uploaded,
                    focus: urlParams.get ? urlParams.get("focus") : urlParams === null || urlParams === void 0 ? void 0 : urlParams.focus
                  }
                });
                updatedState.filters = updatedFilters;
              }
              handleStateUpdate(updatedState, username);
            case 13:
              _context6.next = 18;
              break;
            case 15:
              _context6.prev = 15;
              _context6.t0 = _context6["catch"](0);
              console.warn(_context6.t0);
            case 18:
            case "end":
              return _context6.stop();
          }
        }
      }, _callee6, null, [[0, 15]]);
    }));
    return function (_x8, _x9) {
      return _ref13.apply(this, arguments);
    };
  }(), [currentUsername, filterItemsAreActive, handleStateUpdate, itemBrowserState.filters, itemBrowserState.users, session, urlParams]);

  // Functionality for handling free text search
  var searchTermProps = {
    value: itemBrowserState.searchTerm,
    onCalciteInputInput: function onCalciteInputInput(e) {
      return handleStateUpdate({
        searchTerm: e.target.value
      });
    }
  };
  var userAlreadyAdded = (0, _react.useCallback)(function (username) {
    if (itemBrowserState.users.items.byId[username]) {
      return true;
    }
    return false;
  }, [itemBrowserState.users.items.byId]);

  // This function is used both to add a new user to users state and to switch (click) between users in Users component
  var addUser = (0, _react.useCallback)( /*#__PURE__*/function () {
    var _ref14 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee7(userToAdd, switchActiveAccount) {
      var username, userHasChanged, updatedUsers, updatedUsersStore, stateUpdates, customModifiedUploadedUrlParams, modified_from, modified_to, uploaded_from, uploaded_to;
      return regeneratorRuntime.wrap(function _callee7$(_context7) {
        while (1) {
          switch (_context7.prev = _context7.next) {
            case 0:
              username = userToAdd.username ? userToAdd.username : userToAdd.id;
              userHasChanged = currentUsername !== username;
              updatedUsers = (0, _store.getUpdatedUsersState)({
                username: username,
                userToAdd: userToAdd,
                itemBrowserStateUsers: itemBrowserState.users.items,
                userAlreadyAdded: userAlreadyAdded(username),
                switchActiveAccount: switchActiveAccount
              });
              updatedUsersStore = {
                items: {
                  byId: updatedUsers,
                  allIds: Object.keys(updatedUsers)
                }
              };
              stateUpdates = {
                users: updatedUsersStore
              };
              customModifiedUploadedUrlParams = {};
              if (urlParams && urlParams.get) {
                // If URL params exist upon load of page for custom modified/uploaded date ranges, update state with startDate and endDate for custom modified/created
                modified_from = urlParams.get("modified_from");
                modified_to = urlParams.get("modified_to");
                uploaded_from = urlParams.get("uploaded_from");
                uploaded_to = urlParams.get("uploaded_to");
                if (modified_from && modified_to) {
                  customModifiedUploadedUrlParams = _objectSpread(_objectSpread({}, customModifiedUploadedUrlParams), {}, {
                    "custom-modified": {
                      startDate: parseInt(modified_from),
                      endDate: parseInt(modified_to)
                    }
                  });
                }
                if (uploaded_from && uploaded_to) {
                  customModifiedUploadedUrlParams = _objectSpread(_objectSpread({}, customModifiedUploadedUrlParams), {}, {
                    "custom-created": {
                      startDate: parseInt(uploaded_from),
                      endDate: parseInt(uploaded_to)
                    }
                  });
                }
              }
              handleStateUpdate(stateUpdates, null, customModifiedUploadedUrlParams);
              if (userHasChanged) {
                getUserFolders(username, updatedUsersStore);
              }
            case 9:
            case "end":
              return _context7.stop();
          }
        }
      }, _callee7);
    }));
    return function (_x10, _x11) {
      return _ref14.apply(this, arguments);
    };
  }(), [currentUsername, getUserFolders, handleStateUpdate, itemBrowserState.users.items, urlParams, userAlreadyAdded]);

  // Resets users and folders stores in state (currently used when signing out of active account)
  var resetState = function resetState() {
    handleStateUpdate(_store.defaultItemBrowserState);
  };
  var setAccountInfo = (0, _react.useCallback)( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee8() {
    var switchActiveAccount, options, portalResult;
    return regeneratorRuntime.wrap(function _callee8$(_context8) {
      while (1) {
        switch (_context8.prev = _context8.next) {
          case 0:
            _context8.prev = 0;
            /* Lets addUser() know that actively logged-in user is changing and that users state should be cleared out so that only the actively signed in user should display. */
            switchActiveAccount = true;
            if (!(userAccount && !userAccount.session)) {
              _context8.next = 13;
              break;
            }
            // if user provides REST JS UserSession

            setSession(userAccount);
            options = {
              authentication: userAccount,
              portal: userAccount.portal
            }; // Get portal
            _context8.next = 7;
            return (0, _arcgisRestPortal.getSelf)(options);
          case 7:
            portalResult = _context8.sent;
            setPortal(portalResult);
            // VERIFY THAT THIS WORKS if userAccount is instance of UserSession

            setUser(portalResult === null || portalResult === void 0 ? void 0 : portalResult.user);
            addUser(portalResult === null || portalResult === void 0 ? void 0 : portalResult.user, switchActiveAccount);
            _context8.next = 14;
            break;
          case 13:
            if (userAccount && userAccount.session) {
              // if user provides user session returned from useAccountManagerState
              setSession(userAccount === null || userAccount === void 0 ? void 0 : userAccount.session);
              setPortal(userAccount === null || userAccount === void 0 ? void 0 : userAccount.portal);
              setUser(userAccount === null || userAccount === void 0 ? void 0 : userAccount.user);
              addUser(userAccount === null || userAccount === void 0 ? void 0 : userAccount.user, switchActiveAccount);
            }
          case 14:
            _context8.next = 19;
            break;
          case 16:
            _context8.prev = 16;
            _context8.t0 = _context8["catch"](0);
            console.warn(_context8.t0);
          case 19:
          case "end":
            return _context8.stop();
        }
      }
    }, _callee8, null, [[0, 16]]);
  })), [addUser, userAccount]);
  (0, _react.useEffect)(function () {
    // Checks to see if user has changed and has not already been added
    if (userAccountUsername !== currentUsername && !userAlreadyAdded(userAccountUsername)) {
      setAccountInfo();
    }
  }, [currentUsername, setAccountInfo, userAccountUsername, userAlreadyAdded]);
  return {
    queryResults: queryResults,
    itemBrowserState: itemBrowserState,
    dispatchItemBrowser: dispatchItemBrowser,
    handleStateUpdate: handleStateUpdate,
    currentUsername: currentUsername,
    getUserFolders: getUserFolders,
    handleQueryChange: handleQueryChange,
    sortField: sortField,
    sortOrder: sortOrder,
    searchTermProps: searchTermProps,
    selectedItemIds: selectedItemIds,
    setSelectedItemIds: setSelectedItemIds,
    showFolderFilter: showFolderFilter,
    showUserFilter: showUserFilter,
    portal: portal,
    session: session,
    addUser: addUser,
    urlParams: urlParams,
    resetState: resetState,
    customCellRenderer: customCellRenderer,
    itemGroups: itemGroups,
    columnConfig: columnConfig
  };
};
var _default = useItemBrowserState;
exports.default = _default;